import { ConfirmEmailPage } from '@ppay/client'

import { routes } from '../../router'

export function Page() {
  return <ConfirmEmailPage loginPath={routes.auth.login} />
}
